module.exports = new __parcel__URL__("corruptedsoul.60f16456.png").toString();